const COUPON_STORAGE_KEY = 'jpp.pendingCouponCode';
const COUPON_PATTERN = /^[A-Z0-9]{12}$/;

export function normalizeCouponCode(value: string | null | undefined): string | null {
  const normalized = value?.trim().toUpperCase() ?? '';
  return COUPON_PATTERN.test(normalized) ? normalized : null;
}

export function setPendingCouponCode(value: string | null | undefined): string | null {
  const normalized = normalizeCouponCode(value);
  if (typeof sessionStorage === 'undefined') return normalized;
  if (normalized) {
    sessionStorage.setItem(COUPON_STORAGE_KEY, normalized);
  } else {
    sessionStorage.removeItem(COUPON_STORAGE_KEY);
  }
  return normalized;
}

export function getPendingCouponCode(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  const normalized = normalizeCouponCode(sessionStorage.getItem(COUPON_STORAGE_KEY));
  if (!normalized) sessionStorage.removeItem(COUPON_STORAGE_KEY);
  return normalized;
}

export function clearPendingCouponCode(): void {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(COUPON_STORAGE_KEY);
  }
}

export function clearPendingCouponCodeIfMatches(value: string | null | undefined): void {
  const normalized = normalizeCouponCode(value);
  if (normalized && getPendingCouponCode() === normalized) {
    clearPendingCouponCode();
  }
}

export function captureCouponCode(search: string): string | null {
  const params = new URLSearchParams(search);
  const normalized = normalizeCouponCode(params.get('couponCode'));
  if (normalized) setPendingCouponCode(normalized);
  return normalized;
}

export function addCouponCodeToPath(path: string, couponCode?: string | null): string {
  const normalized = normalizeCouponCode(couponCode) ?? getPendingCouponCode();
  if (!normalized) return path;
  const baseOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://jpp.dajitui.fun';
  const url = new URL(path, baseOrigin);
  url.searchParams.set('couponCode', normalized);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function buildCouponLink(targetPath: string, couponCode: string): string {
  const normalized = normalizeCouponCode(couponCode);
  if (!normalized) throw new Error('INVALID_COUPON_CODE');
  if (typeof window === 'undefined') throw new Error('BROWSER_REQUIRED');

  const rawPath = targetPath.trim();
  if (!rawPath || rawPath.startsWith('//')) throw new Error('INVALID_TARGET_PATH');
  const url = new URL(rawPath, window.location.origin);
  if (url.origin !== window.location.origin || url.pathname.startsWith('/admin')) {
    throw new Error('INVALID_TARGET_PATH');
  }
  url.searchParams.set('couponCode', normalized);
  return url.toString();
}
